export default __webpack_public_path__ + "static/media/log_out_icon.63add308.svg";